import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MailService } from '../../services/mail.service';
import { MatDialog } from '@angular/material/dialog';
import { MessageComponent } from '../../../general/components/message/message.component';

@Component({
  selector: 'app-mail-confirm',
  templateUrl: './mail-confirm.component.html',
  styleUrls: ['./mail-confirm.component.css']
})
export class MailConfirmComponent implements OnInit {

  mailHash = '';
  isValid = false;
  subscribe = false;

  constructor(
    activateRoute: ActivatedRoute,
    private mailService: MailService,
    private router: Router,
    private dialog: MatDialog,
  ) {
    this.mailHash = activateRoute.snapshot.params['mailHash'];
    if (!this.mailHash || typeof(activateRoute.snapshot.data['subscribe']) === 'undefined') {
      this.router.navigate(['']);
    }
    this.subscribe = activateRoute.snapshot.data['subscribe'];
    this.mailService.isHashValid(this.mailHash).subscribe(res => {
      if (res) {
        this.confirmSubscription();
      } else {
        this.router.navigate(['']);
      }
    });
  }

  confirmSubscription() {
    let message = 'Are you sure to unsubscribe your e-mail from our newsletter?';
    if (this.subscribe) {
      message = 'Are you sure to subscribe your e-mail from our newsletter?';
    }
    const dialogRef = this.dialog.open(MessageComponent, {
      disableClose: true,
      data: {
        message: message,
        noCaption: 'No',
        yesCaption: 'Yes'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.mailService.hashAction(this.mailHash, this.subscribe).subscribe(res => {
          if (res) {
            this.router.navigate(this.subscribe ? ['mail/subscribe-result'] : ['mail/unsubscribe-result']);
          } else {
            this.router.navigate(['']);
          }
        });
      } else {
        this.router.navigate(['']);
      }
    });
  }

  ngOnInit() {
  }

}
